<script setup lang="ts">
import VPageContainer from '@shared/layout/VPageContainer/VPageContainer.vue';
import { toRefs } from 'vue';
import { useRelatiesGetRelationByRelatienummer } from '@services/crm-public/orval-api/relaties-api/relaties-api';

import PolisAlertsBeheren from '../../PolisAlertsBeheer/PolisAlertsBeheren.vue';

const props = defineProps<{
  relatienummer: number;
}>();
const { relatienummer } = toRefs(props);

const { isPending, data: adviseurId } = useRelatiesGetRelationByRelatienummer(relatienummer, {
  query: { select: (response) => response?.result?.advisorId ?? 0 },
});
</script>

<template>
  <VPageContainer container-size="sm" title="Alerts" fit-content>
    <PolisAlertsBeheren
      v-if="!isPending"
      :relatienummer
      :adviseurnummer="adviseurId"
      hide-back-button
    />
  </VPageContainer>
</template>
